import React from "react";

interface SidebarProps {
  header?: React.ReactNode;
  action?: React.ReactNode;
  children: React.ReactNode;
}

export default function Sidebar({ header, action, children }: SidebarProps) {
  return (
    <aside className="w-64 h-full p-5 bg-white rounded-2xl shadow-md border border-gray-100 flex flex-col">
      {/* Header */}
      {header && <div className="mb-6">{header}</div>}

      {/* Action (ej: Add Company) */}
      {action && <div className="mb-6">{action}</div>}

      {/* Content */}
      <div className="flex flex-col gap-2 overflow-y-auto">{children}</div>
    </aside>
  );
}
